import { render, staticRenderFns } from "./card_info.vue?vue&type=template&id=08307ffd"
import script from "./card_info.vue?vue&type=script&lang=js"
export * from "./card_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports